import { Injectable } from '@angular/core';
import { SSORosterResponse } from '../models/sso.model';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  sectionAddMessage: { showMessage: boolean, studentList: string[], blockedList: string[] } = {
    showMessage: false,
    studentList: [],
    blockedList: []
  };

  constructor() { }
  // Message to notify user of issues when adding sections from Clever
  setSectionAddMessage(response: SSORosterResponse, currentUserId: number) {
    let studentsWithOtherTeachers = 0;
    this.sectionAddMessage.studentList = [];
    response.moved.forEach((student: any) => {
      if (student.TeacherID !== currentUserId) {
        studentsWithOtherTeachers++;
        this.sectionAddMessage.studentList.push(student.FirstName + " " + student.LastName);
      }
    });

    this.sectionAddMessage.blockedList = response.blocked.map((student: any) => {
      return student.FirstName + " " + student.LastName;
    });

    this.sectionAddMessage.showMessage = this.sectionAddMessage.blockedList.length > 0 || this.sectionAddMessage.studentList.length > 0;
  }

  getSectionAddMessage() {
    return this.sectionAddMessage;
  }

  clearSectionAddMessage() {
    this.sectionAddMessage = {
      showMessage: false,
      studentList: [],
      blockedList: []
    };
  }
}
